<template>
	<div class="bell-video">
		Bell视频  敬请期待prpr
	</div>
</template>

<script>
	export default {
		name: "BellVideo"
	}
</script>

<style scoped>
	.bell-video{
		font-size: 25px;
		font-weight: bold;
	}
</style>